import React from 'react';
import NtsaLogo from '../../assets/images/ntsa.svg';

const NotFound: React.FC = () => {
  return (
    <div className="flex h-screen p-4">
      <div className="w-full flex items-center justify-center p-6">
        <div className="max-w-md w-full space-y-8">
          <img src={NtsaLogo} alt="ntsa" className="h-fit w-fit" />

          <div className="space-y-4">
            <h1 className="text-2xl font-semibold text-gray-800">
              Page Not Found
            </h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              The page you are looking for does not exist. If you received a
              fine notice, please use the link provided in your notification SMS
              or email.
            </p>
            <p className="text-gray-400 text-xs">
              If you believe this is an error, contact NTSA support for
              assistance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
